/* eslint-disable */

import {useEffect, useRef, useCallback} from 'react';
import {useDispatch} from "react-redux";

const WindowWatcher = (props) => {

    const dispatch = useDispatch();
    const resizeEvt = useRef();
    const windowSize = useRef({w:0,h:0});

    const resizeCheck = useCallback(()=>{

        clearTimeout(resizeEvt.current);
        resizeEvt.current = setTimeout(() => {

            let updatedData = getWindowData();
            if (updatedData.width !== windowSize.current.w || updatedData.height !== windowSize.current.h) {
                dispatch({
                    type: "SET_WINDOW_DATA", payload: {
                        ...updatedData,
                        increase: windowSize.current.w < updatedData.width
                    }
                });
            }

            windowSize.current = updatedData
        }, 500);

    },[])

    useEffect(()=>{

        window.addEventListener('resize', resizeCheck);
        window.addEventListener('orientationchange', resizeCheck);

        return ()=>{
            window.removeEventListener('resize', resizeCheck);
            window.removeEventListener('orientationchange', resizeCheck);
        }

    },[resizeCheck]);

    return ''
};

export default WindowWatcher

export function getWindowData() {
    let w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0];

    let width = w.innerWidth || e.clientWidth || g.clientWidth;
    let height = w.innerHeight || e.clientHeight || g.clientHeight;

    let windowData = {
        width: width,
        height: height,
        orientation: width > height ? 'landscape' : 'portrait',
    };

    return windowData;
}